"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.lastFileFeedItems = exports.feedItems = void 0;
var _middlewares = require("./middlewares");
var _normalizr = require("normalizr");
var _schemas = require("../users/schemas");
var feedItems = exports.feedItems = new _normalizr.schema.Entity('feedItems', {
  user: _schemas.user
}, {
  processStrategy: _middlewares.feedItemDiet
});
var lastFileFeedItems = exports.lastFileFeedItems = new _normalizr.schema.Entity('lastFileFeedItems', {
  user: _schemas.user
});